
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface MobileMenuToggleProps {
  isOpen: boolean;
  onClick: () => void;
}

const MobileMenuToggle = ({ isOpen, onClick }: MobileMenuToggleProps) => {
  return (
    <Button 
      variant="ghost" 
      size="icon" 
      onClick={onClick} 
      className="md:hidden"
    >
      {isOpen ? <X size={20} /> : <Menu size={20} />}
    </Button>
  );
};

export default MobileMenuToggle;
